import { render, staticRenderFns } from "./InsFacebook.vue?vue&type=template&id=05815e26&scoped=true"
import script from "./InsFacebook.vue?vue&type=script&lang=ts"
export * from "./InsFacebook.vue?vue&type=script&lang=ts"
import style0 from "./InsFacebook.vue?vue&type=style&index=0&id=05815e26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05815e26",
  null
  
)

export default component.exports